import { defineStore } from 'pinia'
import {
  modelCollectionState,
  modelCollectionActions,
  modelCollectionGetters,
} from '@app/stores/ModelCollectionStore'

export const useSurveyResponseStore = defineStore('SurveyResponseStore', {
  state: () => {
    return { ...modelCollectionState('surveyResponses') }
  },
  getters: { ...modelCollectionGetters('surveyResponses') },
  actions: {
    ...modelCollectionActions('surveyResponses'),
    async fetchRecommendedResponses(...args) {
      args[0]['limit'] = 10
      args[0]['recommended'] = true
      return this.fetchSurveyResponses(...args)
    },
    findResponseByQuestionId(questionId) {
      return this.surveyResponses.find((r) => r.question_id == questionId)
    },
  },
})
